var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"ProfileEdit",attrs:{"justify":"center"}},[_c('v-col',{attrs:{"sm":"10","md":"6"}},[_c('h2',{staticClass:"mb-5"},[_vm._v(_vm._s(_vm.$t('ProfileEdit.title')))]),_c('AppProfileEditForm')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }